import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { MapPin, ArrowRight, Phone } from 'lucide-react';
import { DISTRICT_PAGES } from '../data/districts';
import { PHONES } from '../content';

export default function DistrictLinks() {
  return (
    <section className="section" style={{ background: 'var(--surface)', borderTop: '1px solid var(--border)', borderBottom: '1px solid var(--border)' }}>
      <div className="wrap">
        <div style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
          <div className="pill pill-green" style={{ marginBottom: '1rem' }}>
            <MapPin size={12} style={{ marginRight: 4 }} /> Hizmet Bölgelerimiz
          </div>
          <h2 className="h2">
            Kocaeli'nin <span style={{ color: 'var(--green)' }}>Tüm İlçelerine</span> Hizmet
          </h2>
          <p style={{ color: 'var(--text2)', fontSize: '.875rem', maxWidth: 520, margin: '.75rem auto 0', lineHeight: 1.7 }}>
            13 ilçe ve beldemize 7/24 mobil lastik yol yardım hizmeti sunuyoruz. Bulunduğunuz ilçeyi seçin, detaylı bilgi alın.
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: '1rem',
        }} className="district-links-grid">
          {DISTRICT_PAGES.map((d, i) => (
            <motion.div
              key={d.slug}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: .35, delay: i * .04 }}
            >
              <Link
                to={`/${d.slug}`}
                data-testid={`home-district-${d.slug}`}
                style={{
                  display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                  background: 'var(--card)', border: '1px solid var(--border)',
                  borderRadius: 'var(--r)', padding: '1.125rem 1.25rem',
                  transition: 'border-color .2s, transform .15s', textDecoration: 'none',
                }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--green)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.transform = 'translateY(0)'; }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '.625rem' }}>
                  <div style={{
                    width: 32, height: 32, borderRadius: 8,
                    background: 'rgba(0,200,83,.1)', border: '1px solid rgba(0,200,83,.2)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                  }}>
                    <MapPin size={14} style={{ color: 'var(--green)' }} />
                  </div>
                  <div>
                    <div style={{
                      fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700,
                      fontSize: '.875rem', color: 'var(--text)', lineHeight: 1.2,
                    }}>
                      {d.displayName}
                    </div>
                    <div style={{ fontSize: '.7rem', color: 'var(--text2)', marginTop: '.1rem' }}>
                      Lastik Yol Yardım
                    </div>
                  </div>
                </div>
                <ArrowRight size={14} style={{ color: 'var(--muted)', flexShrink: 0 }} />
              </Link>
            </motion.div>
          ))}
        </div>

        {/* Central CTA */}
        <div style={{ textAlign: 'center', marginTop: '2.5rem' }}>
          <a
            href={PHONES.main_tel}
            data-testid="district-links-call-cta"
            className="btn btn-primary btn-lg ring num"
            style={{ gap: '.5rem' }}
          >
            <Phone size={16} /> Hemen Ara — {PHONES.main}
          </a>
        </div>
      </div>

      <style>{`
        @media(max-width: 1024px) { .district-links-grid { grid-template-columns: repeat(3, 1fr) !important; } }
        @media(max-width: 768px) { .district-links-grid { grid-template-columns: repeat(2, 1fr) !important; } }
        @media(max-width: 480px) { .district-links-grid { grid-template-columns: 1fr !important; } }
      `}</style>
    </section>
  );
}
